module.exports = __webpack_public_path__ + "static/media/ios-contact.d0c3dac9.svg";